import React from "react";
import CaratteristicheDiPortafoglio from "./components/CaratteristicheDiPortafoglio";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import CaratteristicheDiPortafoglioCompare from "./components/CaratteristicheDiPortafoglioCompare";

type SectionChildrenProps = { data: any; data2?: any; label: string };
const CaratteristicheDiPortafoglioContainer: React.FC<SectionChildrenProps> = ({
  data,
  data2,
  label,
}) => {
  if (!data) {
    return <></>;
  }

  return (
    <>
      {!data2 && (
        <div className={commonStyles.sectionContainer}>
          <h3 className={commonStyles.titleChart} style={{ marginTop: 40 }}>
            {label}
          </h3>
          <CaratteristicheDiPortafoglio data={data} />
        </div>
      )}
      {data2 && (
        <div
          className={commonStyles.sectionContainer}
          style={{ marginTop: 40, marginBottom: 10 }}
        >
          <h3 className={commonStyles.titleChart}>{label}</h3>
          <CaratteristicheDiPortafoglioCompare data={data} data2={data2} />
        </div>
      )}
    </>
  );
};
export default React.memo(
  CaratteristicheDiPortafoglioContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    return prevProps.data === nextProps.data;
  },
);
